const r = {
  primary: {
    backgroundColor: "button-primary-bg",
    color: "text-disabled"
  },
  secondary: {
    backgroundColor: "button-secondary-bg",
    color: "text-disabled"
  },
  tertiary: {
    backgroundColor: "transparent",
    borderColor: "button-tertiary-border",
    color: "text-disabled"
  },
  quaternary: {
    color: "text-disabled"
  }
};
export {
  r as loading
};
